import React from 'react';
import Header from 'app/components/layout/Header';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Progress, Label } from 'reactstrap';
import Isvg from 'react-inlinesvg';
import { ITeamPaymentRequest } from 'app/ducks/teamPaymentRequests/types';
import { parseAmount, friendlyDate, simpleDateNoTime } from 'app/utils/parsers';
import Checkbox from 'app/components/general/Checkbox';
import Alert from 'app/components/general/Alert';
import IconModal from 'app/components/general/IconModal';
import Button from 'app/components/general/Button';
import SectionGroup from 'app/components/general/SectionGroup';
import StatusBadge from 'app/components/general/StatusBadge';
import PaymentCardMin from 'app/components/matches/PaymentCardMin';
import ModalConfirm from 'app/components/general/ModalConfirm';
import LinkIcon from 'app/images/icons/linked.svg';

import PaymentCollectionsTableTeamMembers from 'app/components/teamPaymentRequests/PaymentCollectionsTableTeamMembers';
import LinkMatchTeamPaymentRequest from 'app/components/teamPaymentRequests/LinkMatchTeamPaymentRequest';
import * as teamPaymentRequestActions from 'app/ducks/teamPaymentRequests/actions';
import * as reminderActions from 'app/ducks/reminders/actions';
import * as teamPaymentCollectionActions from 'app/ducks/teamPaymentCollections/actions';

import * as loadingSelectors from 'app/ducks/loading/selectors';
import * as teamPaymentRequestsSelectors from 'app/ducks/teamPaymentRequests/selectors';
import * as remindersSelectors from 'app/ducks/reminders/selectors';
import * as teamPaymentCollectionsSelectors from 'app/ducks/teamPaymentCollections/selectors';
import * as organisationsSelectors from 'app/ducks/organisations/selectors';
import * as paymentEventsActions from 'app/ducks/paymentEvents/actions';
import * as paymentEventsSelectors from 'app/ducks/paymentEvents/selectors';

import CompetitionIcon from 'app/images/icons/organisation.svg';
import _ from 'lodash';
import Step2SelectTeamMembers from '../NewPaymentRequest/Step2SelectTeamMembers';

interface ITeamPaymentRequestDetailProps {
  actions?: any;
  match?: any;
  organisations?: any;
  reminders?: any;
  teamPaymentRequests?: any;
  teamPaymentCollections?: any;
  paymentEvents?: any;
  appReady?: boolean;
}

interface ITeamPaymentRequestDetailState {
  initialFilter: any;
  error?: string;
  disconnectMatchModalOpen?: boolean;
  linkMatchModalOpen?: boolean;
  addPersonToRequestModalOpen?: boolean;
}

const formatSentAtText = (dateTime: any): string => {
  const parsedDate = simpleDateNoTime(dateTime);

  if (parsedDate === 'Invalid date') {
    return 'Sent';
  }
  return `Sent at ${parsedDate}`;
};

function selector(state) {
  return {
    teamPaymentRequests: teamPaymentRequestsSelectors.getTeamPaymentRequests(state),
    teamPaymentCollections: teamPaymentCollectionsSelectors.getTeamPaymentCollections(state),
    paymentEvents: paymentEventsSelectors.getPaymentEvents(state),
    reminders: remindersSelectors.getReminders(state),
    organisations: organisationsSelectors.getOrganisations(state),
    appReady: loadingSelectors.appReady(state),
  };
}

const actionCreators = _.merge(
  teamPaymentRequestActions,
  teamPaymentCollectionActions,
  reminderActions,
  paymentEventsActions,
);

@connect(
  selector,
  (dispatch) => ({
    actions: bindActionCreators(actionCreators, dispatch),
  }),
)
export default class PaymentRequestDetail extends React.Component<ITeamPaymentRequestDetailProps, ITeamPaymentRequestDetailState> {
  static defaultProps: ITeamPaymentRequestDetailProps = {
    actions: undefined,
    match: undefined,
    teamPaymentRequests: undefined,
    teamPaymentCollections: undefined,
    appReady: false,
  };

  state = {
    disconnectMatchModalOpen: false,
    linkMatchModalOpen: false,
  }

  timer;

  componentDidMount(): void {
    this.props.actions.clearPaymentCollections();
    this.props.actions.getTeamPaymentRequest(this.props.match.params.paymentRequestId);
    // TODO - Filter
    // this.props.actions.getAllPaymentEvents({
    //   matchPaymentId: this.props.teamPaymentRequests?.currentTeamPaymentRequest?.matchPayment?.id,
    //   groupId: this.props.teamPaymentRequests?.currentTeamPaymentRequest?.group?.id,
    // });
    this.timer = setInterval(this.checkForPaymentRequestUpdates, 5000);
  }

  componentWillUnmount(): void {
    clearInterval(this.timer);
    this.timer = null;
  }

  checkForPaymentRequestUpdates = (): void => {
    if (this.props.teamPaymentRequests?.currentTeamPaymentRequest?.status === 'setting-up') {
      this.props.actions.getTeamPaymentRequest(this.props.match.params.paymentRequestId);
    } else {
      clearInterval(this.timer);
    }
  }

  handleDisconnectMatch = (): void => {
    // event.stopPropagation();
    if (!this.props.teamPaymentRequests.isLoading) {
      this.props.actions.updateTeamPaymentRequest({
        id: this.props.teamPaymentRequests.currentTeamPaymentRequest.id,
        matchPayment: {
          id: null,
        },
        group: {
          id: null,
        },
      });
      this.setState({ disconnectMatchModalOpen: false });
    }
  };

  renderDisconnectMatchModal = (): React.ReactNode => (
    <ModalConfirm
      title="Disconnect Match"
      description="This will un-link this payment request from the match. Are you sure you want to do this?"
      buttonText="Disconnect"
      isOpen={this.state.disconnectMatchModalOpen}
      isLoading={this.props.teamPaymentRequests.isSaving}
      hasFailed={this.props.teamPaymentRequests.hasFailed}
      hasSaved={this.props.teamPaymentRequests.hasSaved}
      handleSubmit={this.handleDisconnectMatch}
      handleCancel={this.handleCloseDisconnectMatchModal}
    />
  );

  handleOpenDisconnectMatchModal = (): void => {
    this.setState({ disconnectMatchModalOpen: true });
  }

  handleCloseDisconnectMatchModal = (): void => {
    this.setState({ disconnectMatchModalOpen: false });
  }

  handleOpenLinkMatchModal = (e): void => {
    e.preventDefault();
    this.setState({ linkMatchModalOpen: true });
  };

  handleCloseLinkMatchModal = (e): void => {
    // e.preventDefault();
    this.setState({ linkMatchModalOpen: false });
  };

  handleOpenAddPersonToRequestModal = (e): void => {
    e.preventDefault();
    this.setState({ addPersonToRequestModalOpen: true });
  };

  handleCloseAddPersonToRequestModal = (e): void => {
    // e.preventDefault();
    this.setState({ addPersonToRequestModalOpen: false });
  };

  render(): React.ReactNode {
    const teamPaymentRequest: ITeamPaymentRequest = this.props.teamPaymentRequests.currentTeamPaymentRequest;
    // if (_.isEmpty(teamPaymentRequest)) {
    //   return null;
    // }
    const currentPaymentEventId = _.find(this.props.paymentEvents.paymentEventIds, (id) => {
      const pe = this.props.paymentEvents.paymentEventsById[id];
      if (pe.groupOne?.id === teamPaymentRequest.group?.id && pe.groupOneMatchPayment?.id === teamPaymentRequest.matchPayment?.id) {
        return true;
      }
      if (pe.groupTwo?.id === teamPaymentRequest.group?.id && pe.groupTwoMatchPayment?.id === teamPaymentRequest.matchPayment?.id) {
        return true;
      }
      return false;
    });
    const currentPaymentEvent = this.props.paymentEvents.paymentEventsById[currentPaymentEventId];
    const progressPercentage = teamPaymentRequest.collectedAmount === 0 ? 0
      : (teamPaymentRequest.collectedAmount / teamPaymentRequest.totalAmount) * 100;
    const isLoading = this.props.teamPaymentRequests.isLoading && teamPaymentRequest.id !== this.props.match.params.paymentRequestId;
    const initialReminder = teamPaymentRequest.notificationLog?.sendSmsInitialNotificationTeamMembers || {
      sent: true,
      sentOn: teamPaymentRequest.createdAt,
    };
    const reminderStatuses = {
      smsInitial: {
        enabled: teamPaymentRequest.notificationConfiguration?.sendSmsInitialNotificationTeamMembers || true,
        sent: initialReminder?.sent || false,
        text: initialReminder?.sent ? formatSentAtText(initialReminder.sentOn) : 'Not sent',
      },
      emailInitial: {
        enabled: teamPaymentRequest.notificationConfiguration?.sendEmailInitialNotificationTeamMembers || false,
        sent: teamPaymentRequest.notificationLog?.sendEmailInitialNotificationTeamMembers?.sent || false,
        text: teamPaymentRequest.notificationLog?.sendEmailInitialNotificationTeamMembers?.sent ? formatSentAtText(teamPaymentRequest.notificationLog?.sendEmailInitialNotificationTeamMembers.sentOn) : 'Not sent',
      },
      smsDue: {
        enabled: teamPaymentRequest.notificationConfiguration?.sendSmsDueReminderTeamMembers || false,
        sent: teamPaymentRequest.notificationLog?.sendSmsDueReminderTeamMembers?.sent || false,
        text: teamPaymentRequest.notificationLog?.sendSmsDueReminderTeamMembers?.sent ? formatSentAtText(teamPaymentRequest.notificationLog?.sendSmsDueReminderTeamMembers.sentOn) : 'Not sent',
      },
      emailDue: {
        enabled: teamPaymentRequest.notificationConfiguration?.sendEmailDueReminderTeamMembers || false,
        sent: teamPaymentRequest.notificationLog?.sendEmailDueReminderTeamMembers?.sent || false,
        text: teamPaymentRequest.notificationLog?.sendEmailDueReminderTeamMembers?.sent ? formatSentAtText(teamPaymentRequest.notificationLog?.sendEmailDueReminderTeamMembers.sentOn) : 'Not sent',
      },
    };
    const formattedPaymentText = teamPaymentRequest.status === 'pending' ? 'Collecting' : undefined;

    const actions = [];

    if (teamPaymentRequest.pending > 0) {
      actions.push(<Button
        className="btn btn-2 btn-small margin-right-10 margin-bottom-10"
        hasFailed={this.props.reminders.hasFailed}
        hasSaved={this.props.reminders.hasSaved}
        errorText="Reminder already sent"
        isLoading={this.props.reminders.isSaving}
        onClick={(e): void => {
          e.stopPropagation();
          if (!this.props.reminders.isLoading) {
            this.props.actions.createReminder({
              paymentRequests: [
                {
                  id: teamPaymentRequest.id,
                },
              ],
            });
          }
        }}
      >
        Send Reminders
      </Button>);
    }
    if (teamPaymentRequest.matchPayment?.id === null) {
      actions.push(<Button
        className="btn-standard btn-small btn-2  margin-right-10 margin-bottom-10"
        noLoading
        onClick={this.handleOpenLinkMatchModal}
      >
        Link to Match
      </Button>);
    }
    return (
      <div>
        {this.renderDisconnectMatchModal()}
        <IconModal
          title="Link to Match"
          icon={LinkIcon}
          handleCancel={this.handleCloseLinkMatchModal}
          isOpen={this.state.linkMatchModalOpen}
          afterSubmit={this.handleCloseLinkMatchModal}
          className="w-100"
        >
          <LinkMatchTeamPaymentRequest {...this.props} teamPaymentRequestId={this.props.match.params.teamPaymentRequestId} afterSubmit={this.handleCloseLinkMatchModal} />
        </IconModal>
        {/* <IconModal
          title="Add Person to Request"
          icon={PlusIcon}
          handleCancel={this.handleCloseAddPersonToRequestModal}
          isOpen={this.state.addPersonToRequestModalOpen}
          afterSubmit={this.handleCloseAddPersonToRequestModal}
          className="w-100"
        >
          <Step2SelectTeamMembers {...this.props} teamPaymentRequestId={this.props.match.params.teamPaymentRequestId} afterSubmit={this.handleCloseLinkMatchModal} />
        </IconModal> */}
        <div className="row">
          <div className="col">
            <Header
              title={teamPaymentRequest.description}
              isLoading={isLoading}
              badge={(
                <StatusBadge
                  formattedPaymentText={formattedPaymentText}
                  paymentText={teamPaymentRequest.status}
                />
              )}
              metadata={[
                {
                  title: 'Date Requested',
                  value: teamPaymentRequest.createdAt !== undefined ? friendlyDate(teamPaymentRequest.createdAt) : '',
                },
                {
                  title: 'Due Date',
                  value: teamPaymentRequest.dueAt !== undefined ? friendlyDate(teamPaymentRequest.dueAt) : '',
                },
                {
                  title: '# of Team Members',
                  value: teamPaymentRequest.numberOfTeamMembers?.toString(),
                },
                {
                  title: '# of Teams',
                  value: teamPaymentRequest.numberOfTeams?.toString(),
                },
                // {
                //   title: 'Date Due',
                //   value: teamPaymentRequest.dueAt !== undefined ? simpleDateNoTime(teamPaymentRequest.dueAt) : '',
                // },
              ]}
            />
          </div>
        </div>
        <div className="main-content">
          {teamPaymentRequest.status === 'setting-up' && (
            <div className="row with-margin-bottom-extra">
              <div className="col col-12 col-lg-8">
                <Alert color="info">Payment requests are currently being sent out to selected team members in the background. No further action is required. The data below will refresh once requests have been sent, you do not need to stay on this page.</Alert>
              </div>
            </div>
          )}
          <div className="row">
            <div className="col col-12 col-lg-8 col-xl-7 with-margin-bottom-extra">
              <SectionGroup title="Summary">
                <div className="row with-margin-top-10">
                  <div className="col">
                    <Progress multi>
                      <Progress bar color="green" value={progressPercentage} />
                      <Progress bar color="grey" value={100 - progressPercentage} />
                    </Progress>
                  </div>
                </div>
                <div className="row with-margin-top-10">
                  <div className="col text-left normal-text">
                    {parseAmount(
                      teamPaymentRequest.collectedAmount,
                    )}
                  </div>
                  <div className="col text-right normal-text">
                    {parseAmount(
                      teamPaymentRequest.totalAmount,
                    )}
                  </div>
                </div>
              </SectionGroup>
            </div>
            {!_.isEmpty(currentPaymentEvent) && (
              <div className="col">
                <SectionGroup
                  title="Linked Match"
                // buttons={(
                //   <div className="btn-flex-group w-100">
                //     <div className="btn-flex-container float-right">
                //       <Button
                //         className="btn-2"
                //         onClick={this.handleOpenDisconnectMatchModal}
                //       >
                //         Disconnect Match
                //       </Button>
                //     </div>
                //   </div>
                // )}
                >
                  <div className="row">
                    <div className="col">
                      <PaymentCardMin
                        {...paymentEventsSelectors.getPaymentEventForMatchCard(
                          currentPaymentEvent,
                          teamPaymentRequest?.group?.id,
                        )}
                        truncated
                      />

                    </div>
                  </div>
                  <div className="row with-margin-top">
                    <div className="col">
                      <div className="btn-flex-group w-100">
                        <div className="btn-flex-container float-right">
                          <Button
                            className="btn-2"
                            onClick={this.handleOpenDisconnectMatchModal}
                          >
                            Disconnect Match
                          </Button>
                        </div>
                      </div>
                    </div>
                  </div>

                </SectionGroup>
              </div>
            )}
          </div>
          {actions.length > 0 && (
            <div className="row with-margin-top-extra">
              <div className="col col-12 col-lg-8 col-xl-7">
                <SectionGroup title="Actions" isLoading={isLoading}>
                  {_.map(actions, (a) => a)}
                </SectionGroup>
              </div>
            </div>
          )}
          <div className="row with-margin-top-extra">
            <div className="col col-12 col-lg-8 col-xl-7">
              <SectionGroup title="Details" isLoading={isLoading}>
                <div className="row">
                  <div className="col col-6 col-xl-4 text-grey">
                    Description
                  </div>
                  <div className="col">
                    {teamPaymentRequest.description}
                  </div>
                </div>
                <div className="row with-margin-top-10">
                  <div className="col col-6 col-xl-4 text-grey">
                    Number of Team Members
                  </div>
                  <div className="col">
                    {teamPaymentRequest.total}
                  </div>
                </div>
                {/* <div className="row with-margin-top-10">
                  <div className="col col-6 col-xl-4 text-grey">
                    Amount per Team Member
                  </div>
                  <div className="col">
                    {parseAmount(teamPaymentRequest.amountInCents)}
                  </div>
                </div> */}
                <div className="row with-margin-top-10">
                  <div className="col col-6 col-xl-4 text-grey">
                    Total requested
                  </div>
                  <div className="col">
                    {parseAmount(teamPaymentRequest.totalAmount)}
                  </div>
                </div>
                <div className="row with-margin-top-10">
                  <div className="col col-6 col-xl-4 text-grey">
                    Team manager amount
                  </div>
                  <div className="col">
                    {parseAmount(teamPaymentRequest.deductedAmount)}
                  </div>
                </div>
                <div className="row with-margin-top-10">
                  <div className="col col-6 col-xl-4 text-grey">
                    Total number collected
                  </div>
                  <div className="col">
                    {teamPaymentRequest.collected}
                  </div>
                </div>
                <div className="row with-margin-top-10">
                  <div className="col col-6 col-xl-4 text-grey">
                    Total amount collected
                  </div>
                  <div className="col">
                    {parseAmount(teamPaymentRequest.collectedAmount)}
                  </div>
                </div>
              </SectionGroup>
            </div>
          </div>
          <div className="row with-margin-top-extra">
            <div className="col">
              {this.props.teamPaymentRequests.currentTeamPaymentRequest?.id !== undefined && this.props.teamPaymentRequests.currentTeamPaymentRequest?.status !== 'setting-up' && (
                <PaymentCollectionsTableTeamMembers
                  {...this.props.teamPaymentCollections}
                  headerTitle="Payment Collections"
                  appReady={this.props.appReady}
                  actions={this.props.actions}
                  saveFilters={false}
                  aggressiveLoader
                  teamPaymentRequestId={this.props.match.params.paymentRequestId}
                  isLoading={this.props.teamPaymentCollections.isLoading}
                  persistentFilterConfig={{
                    paymentRequestId: this.props.match.params.paymentRequestId,
                  }}
                  selectPaymentCollection={this.props.actions.selectPaymentCollection}
                />
              )}
              {/* {this.props.teamPaymentRequests.currentTeamPaymentRequest?.teamPaymentRequestType === 'team-request' && (
                <PaymentCollectionsTableTeams
                  {...this.props.teamPaymentCollections}
                  headerTitle="Payment Collections"
                  appReady={this.props.appReady}
                  actions={this.props.actions}
                  saveFilters={false}
                  isLoading={this.props.teamPaymentCollections.isLoading}
                  persistentFilterConfig={{
                    teamPaymentRequestId: teamPaymentRequest.id,
                  }}
                  selectPaymentCollection={this.props.actions.selectPaymentCollection}
                />
              )} */}
            </div>
          </div>
        </div>
      </div>
    );
  }
}
